import type { OrganizationList } from 'models';
import { Avatar, DetailsCategoryItem } from 'ui';
import { images } from 'common/utils';

type P = {
  organization: OrganizationList;
};

const DetailsOrganization = ({ organization }: P) => (
  <DetailsCategoryItem
    category="organization"
    icon={
      <Avatar
        alt="Organization profile photo"
        fallbackPhoto={images.default.organizationProfilePhoto}
        photo={
          organization.squareLogo?.url ?? organization.profilePhoto?.url ?? images.default.organizationProfilePhoto
        }
        size={32}
      />
    }
    name={organization.name}
  />
);

export default DetailsOrganization;
